<template>
    <div class="solutions">
        <h2>
             <masked-image class="icon_title" src="/img/icons/price.svg"></masked-image>
             {{ lang.title | capitalize }}
        </h2>
        <div class="solution-list">
            <template v-for="(solution, index) in solutions">
                <div :key="'data-' + solution.id" class="row align-items-center">
                    <div
                        v-if="solution.media.images[0]"
                        class="solutions_list_image col-sm-2"
                        :style="'background-image: url(' + solution.media.images[0]['url']['gallery_preview'] + ')'"
                        @click="showSolutionsImage(index)">
                    </div>
                    <div class="col-sm-3">
                        <div class="solution-title">{{ solution.subtype }}</div>
                        <div class="current-price">€ {{ solution.price }}</div>
                    </div>
                    <div class="col-sm-7 solution-data">
                        <span class="estate-card-surface"><masked-image src="/img/icons/surface.svg"></masked-image> {{ solution.surface }} {{ lang.surface | capitalize }}</span>
                        <span v-if="solution.floor != null" class="estate-card-floor"><masked-image src="/img/icons/floor.svg"></masked-image>  {{ solution.floor }} {{ lang.floor | capitalize }}</span>
                        <!-- <span  v-if="solution.rooms > 0" class="estate-card-rooms"><masked-image src="/img/icons/rooms.svg"></masked-image> {{ solution.rooms }} {{ lang.rooms | capitalize }}</span> -->
                        <span>
                            <a
                                class="solution-info"
                                @click="toggleDescription(solution.id)"
                            >
                                <masked-image src="/img/icons/info-circle.svg" />
                            </a>
                        </span>
                        <modal-opener
                            name="solution-lead"
                            :data="{ solutionId: solution.id }"
                        >
                            <span class="solution-lead">
                                <masked-image src="/img/icons/email.svg" />
                            </span>
                        </modal-opener>
                    </div>
                    <div v-if="descriptionIsShown(solution.id)" :key="'description-' + solution.id" class="col-12 p-0">
                        <div class="well">
                            <span v-html="solution.description"></span>
                        </div>
                    </div>
                </div>
            </template>
        </div>


<!-- 
        <table class="table table-striped ">
            <thead>
                <tr>
                    <th class="is-hidden-mobile">{{ lang.floor_plan | capitalize }}</th>
                
                    <th>{{ lang.type | capitalize }}</th>
                    <th>{{ lang.surface | capitalize }}</th>
                    <th>{{ lang.price | capitalize }}</th>
                    <th class="is-hidden-mobile">{{ lang.floor | capitalize }}</th>
                    <th class="is-hidden-mobile">{{ lang.rooms | capitalize }}</th>
                    <th>{{ lang.details | capitalize }}</th>
                </tr>
            </thead>

            <tbody>
                <template v-for="(solution, index) in solutions">
                    <tr :key="'data-' + solution.id">
                        <td scope="row" class="is-hidden-mobile">
                            <div
                                v-if="solution.media.images[0]"
                                class="solutions_list_image"
                                :style="'background-image: url(' + solution.media.images[0]['url']['gallery_preview'] + ')'"
                                @click="showSolutionsImage(index)"></div>
                        </td>
                        
                        <td>{{ solution.subtype }}</td>
                        <td>{{ solution.surface }} {{ lang.surface | capitalize }}</td>
                        <td>€ {{ solution.price }}</td>
                        <td class="is-hidden-mobile">{{ solution.floor }}</td>
                        <td class="is-hidden-mobile">{{ solution.rooms }}</td>
                        <td class="solution-buttons">
                            <a
                                class="solution-button btn btn-text"
                                @click="toggleDescription(solution.id)"
                            >
                                <masked-image src="/img/icons/search.svg" />
                            </a>

                            <modal-opener
                                name="solution-lead"
                                class="solution-button solution-lead"
                                :data="{ solutionId: solution.id }"
                            >
                                <a class="btn btn-text">
                                    <masked-image src="/img/icons/email.svg" />
                                </a>
                            </modal-opener>
                        </td>
                    </tr>

                    <tr v-if="descriptionIsShown(solution.id)" :key="'description-' + solution.id">
                        <td colspan="8">
                            <div class="well">
                                <div class="row">
                                    <div class="col-md-12">
                                        <span v-html="solution.description"></span>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table> -->

        <modal
            name="solution-lead"
            ref="solution-lead"
            extra-class="full-screen-modal solution-lead-modal"
            :title="trans('lead')"
            icon= "email.svg"
        >
            <template slot="body" slot-scope="props">
                <lead-form :estate="estate" :solution-id="props.data.solutionId" />
            </template>
        </modal>
    </div>
</template>

<script>
import Modal from '../Modal'
import ModalOpener from '../ModalOpener'
import LeadForm from '../../components/LeadForm'

export default {
    components: {
        'modal': Modal,
        'modal-opener': ModalOpener,
        'lead-form': LeadForm,
    },

    props: {
        estate: {
            type: Object,
            required: true,
        },

        solutions: {
            type: Array,
            required: true,
        }
    },

    data() {
        return {
            visible_descriptions: [],
        }
    },

    computed: {
        lang() {
            return this.$root.lang.constructions_solutions
        }
    },

    methods: {
        descriptionIsShown(id)  {
            return this.visible_descriptions.includes(id)
        },

        toggleDescription(id) {
            if(this.descriptionIsShown(id)) {
                let index = this.visible_descriptions.indexOf(id)

                this.visible_descriptions.splice(index, 1)
            }
            else {
                this.visible_descriptions.push(id)
            }
        },

        showSolutionsImage(solution) {
            let solution_data = this.solutions[solution]
            solution_data.price = solution_data.price ? this.lang.currency + ' ' + solution_data.price : ''
            solution_data.rooms = solution_data.rooms ? solution_data.rooms + ' ' + this.lang.rooms : ''
            solution_data.surface = solution_data.surface ? solution_data.surface + ' ' + this.lang.surface : ''
            window.events.$emit('showModal', {
                name: 'media-gallery', 
                data: {
                    estate: solution_data,
                    buttons: false
                },
            })
        },
    }
}
</script>
